<template>
  <v-card style="margin-bottom:1em" class="RelatorioDadosCampanhasFiltros">
    <v-form ref="form" autocomplete="off">
      <v-card-title>
        <div class="title">{{ $tc('title.detalhamento_planejamento_verbas', 1) }}</div>
        <v-spacer></v-spacer>
        <v-icon v-show="mostrarFiltros"
          @click="fixaFiltros"
          :class="filtrosFixosClass"
          style="margin-right: 10px"
          >fa-thumbtack</v-icon>
        <v-icon @click="toggleMostrarFiltros">filter_list</v-icon>
      </v-card-title>
      <v-container fluid grid-list-md v-show="mostrarFiltros">
        <metadados-container-layout
          v-if="camposFormulario !== null"
          :ordenacao-campos="ordenacaoCampos"
          :campos-formulario="camposFormulario"
          :explode-hierarquia="true"
          :formulario-filtros="true"
          :ignora-obrigatorios="true"
          :objeto="filtrosDadosCampanhas"
          ref="container">
          <v-col cols="12" sm="6" md="4" slot="antes">
            <v-menu
              ref="menuMesVigenciaPesquisa"
              :close-on-content-click="false"
              v-model="menuMesVigenciaPesquisa"
              id="mes_pesquisa"
              name="mes_pesquisa"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              :return-value.sync="mesVigenciaPesquisa"
              max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="mesVigenciaPesquisa"
                  multiple
                  chips
                  deletable-chips
                  clearable
                  :label="$t('label.mes_vigencia')"
                  prepend-icon="event"
                  :rules="[required]"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker locale="pt-br" color="primary" type="month" multiple v-model="mesVigenciaPesquisa">
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menuMesVigenciaPesquisa = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menuMesVigenciaPesquisa.save(mesVigenciaPesquisa)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4" slot="depois" v-if="isAmbienteMagalu">
            <v-menu
              ref="menuMesContabilizacaoPesquisa"
              :close-on-content-click="false"
              v-model="menuMesContabilizacaoPesquisa"
              id="mes_pesquisa"
              name="mes_pesquisa"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              :return-value.sync="mesContabilizacaoPesquisa"
              max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="mesContabilizacaoPesquisa"
                  multiple
                  chips
                  deletable-chips
                  clearable
                  :label="$t('label.mes_contabilizacao')"
                  prepend-icon="event"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker locale="pt-br" color="primary" type="month" multiple v-model="mesContabilizacaoPesquisa">
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menuMesContabilizacaoPesquisa = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menuMesContabilizacaoPesquisa.save(mesContabilizacaoPesquisa)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </metadados-container-layout>
      </v-container>
      <v-card-actions v-show="mostrarFiltros">
        <v-spacer></v-spacer>
        <v-btn @click="resetaFiltros"
          color="accent"
        >{{$t('label.limpar_filtros')}}</v-btn>
        <v-btn @click="aplicarFiltros"
          color="primary"
        >{{$t('label.exportar')}}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>

import { skipLoading } from '@/common/functions/loading';
import { mapGetters } from 'vuex';
import { countRelatorioDadosCampanhas } from '@/common/resources/magalu-relatorios'; // eslint-disable-line
import MetadadosContainerLayout from '@/shared-components/metadados/MetadadosContainerLayout';
import MetadadosCampoDinamicoData from '@/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoData';
import RelatorioDadosCampanhasFiltrosCampos from './RelatorioDadosCampanhasFiltrosCampos';

export default {
  name: 'RelatorioDadosCampanhas',
  mixins: [
    RelatorioDadosCampanhasFiltrosCampos,
  ],
  watch: {
    filtrosDadosCampanhas: {
      handler() {
        this.umFiltroObrigatorioSelecionado = false;
        if (this.mesVigenciaPesquisa && this.mesVigenciaPesquisa.length) {
          this.umFiltroObrigatorioSelecionado = true;
        }

        Object.values(this.filtrosDadosCampanhas).every((value) => {
          if (value instanceof Array) {
            if (value && value.length) {
              this.umFiltroObrigatorioSelecionado = true;
              return false;
            }
          } else if (value) {
            this.umFiltroObrigatorioSelecionado = true;
            return false;
          }
          return true;
        });
        this.$refs.form.resetValidation();
      },
      deep: true,
    },
  },
  computed: {
    filtrosFixosClass() {
      return {
        'primary--text': this.filtrosFixados,
        'mr-2': true,
      };
    },
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    isAmbienteMagalu() {
      return this.chaveEmpresa === 'MAGALU';
    },
    isAmbienteEpoca() {
      return this.chaveEmpresa === 'EPOCA';
    },
    isAmbienteKabum() {
      return this.chaveEmpresa === 'KABUM';
    },
  },
  components: {
    MetadadosContainerLayout,
    MetadadosCampoDinamicoData,
  },
  data() {
    return {
      ordenacaoCampos: [
        'grupo_fornecedor',
        'status',
        'categoria',
        'tipo_acao',
        'origem',
        'modalidade',
      ],
      mostrarFiltros: false,
      filtrosFixados: false,
      filtrosDadosCampanhas: {},
      umFiltroObrigatorioSelecionado: true,
      limiteRegistrosExportacao: 50000,
      menuMesVigenciaPesquisa: false,
      menuMesContabilizacaoPesquisa: false,
      mesAnoAtual: this.moment().format('YYYY-MM'),
      mesVigenciaPesquisa: [],
      mesContabilizacaoPesquisa: [],
      mesesVigenciaList: [],
      mesesContabilizacaoString: [],
      camposFormulario: null,
    };
  },
  methods: {
    required(value) {
      if (value instanceof Array && value.length === 0) {
        return this.$t('message.campo_obrigatorio');
      }
      return !!value || this.$t('message.campo_obrigatorio');
    },
    toggleMostrarFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    filtroValido() {
      // valida se algum filtro foi selecionado
      return this.umFiltroObrigatorioSelecionado;
    },
    resetaFiltros() {
      this.filtrosDadosCampanhas = {};
      this.mesVigenciaPesquisa = [this.mesAnoAtual];
      this.mesContabilizacaoPesquisa = [];
    },
    aplicarFiltros() {
      this.mesesVigenciaList = [];
      this.mesesContabilizacaoString = [];
      const filtrosAplicados = this.$refs.container.getValoresCamposPadrao();

      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.filtroValido()) {
        this.$toast(this.$t('message.selecione_um_filtro_obrigatorio'));
        return;
      }
      if (filtrosAplicados.origem !== null && typeof filtrosAplicados.origem !== 'undefined') {
        if (filtrosAplicados.origem === 'CONTRATO') {
          filtrosAplicados.contrato = true;
        } else {
          filtrosAplicados.acao = true;
        }
      }

      this.mesVigenciaPesquisa.forEach((anoMes) => {
        this.mesesVigenciaList.push(parseInt(anoMes.replaceAll('-', ''), 10));
      });

      this.mesContabilizacaoPesquisa.forEach((anoMes) => {
        this.mesesContabilizacaoString.push(parseInt(anoMes.replaceAll('-', ''), 10));
      });

      const mesesVigencia = this.mesesVigenciaList;
      const mesesContabilizacao = this.mesesContabilizacaoString;

      const params = {
        ...filtrosAplicados,
        mesesVigencia,
        meses_vigencia: mesesVigencia,
        meses_contabilizacao: mesesContabilizacao,
        min_mes_vigencia: Math.min(...mesesVigencia),
        max_mes_vigencia: Math.max(...mesesVigencia),
      };

      let quantidadeRegistros = 0;

      countRelatorioDadosCampanhas(params, this.$resource)
        .then((response) => {
          quantidadeRegistros = response.data;
          if (quantidadeRegistros > this.limiteRegistrosExportacao) {
            this.$toast(this.$t('errors.registros.excede_limite_dados', { limite: this.limiteRegistrosExportacao }));
          } else if (quantidadeRegistros > 0) {
            let nomeRelatorio = '';
            if (this.isAmbienteKabum) {
              nomeRelatorio = 'dados_campanhas_kabum';
            } else if (this.isAmbienteEpoca) {
              nomeRelatorio = 'dados_campanhas_epoca';
            } else {
              nomeRelatorio = 'dados_campanhas';
            }
            this.$emit('RelatorioExportacaoDadosCampanhas__AplicaFiltros',
              params,
              nomeRelatorio,
              'api');
          } else {
            this.$toast(this.$t('errors.registros.nao_ha_dados'));
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    fixaFiltros() {
      this.filtrosFixados = !this.filtrosFixados;
      this.workspace.indAberto = this.filtrosFixados;
      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
    inserirWorkspace() {
      skipLoading();
      const entidade = 'relatorio-dados-campanhas';
      this.workspaceFiltrosResources.inserir({ entidade }, this.workspace)
        .then((response) => {
          this.workspace.id = response.data;
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    atualizarWorkspace() {
      skipLoading();
      const entidade = 'relatorio-dados-campanhas';
      this.workspaceFiltrosResources.atualizar({ entidade }, this.workspace)
        .then()
        .catch((err) => {
          this.$error(this, err);
        });
    },
    salvarFiltrosWorkspace() {
      this.workspace.filtros = this.filtrosDadosCampanhas;
      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
  },
  mounted() {
    this.mesVigenciaPesquisa.push(this.mesAnoAtual);
    if (this.isAmbienteKabum) {
      this.camposFormulario = this.camposFormularioKabum;
    } else if (this.isAmbienteEpoca) {
      this.camposFormulario = this.camposFormularioEpoca;
    } else {
      this.camposFormulario = this.camposFormularioMagalu;
    }
  },
};
</script>
<style>
  .RelatorioBaseContratos__Opcoes {
    padding: 0 0 0 20px;
    margin-top: 0;
  }
  .RelatorioBaseContratos__Opcoes div.v-input__slot,
  .RelatorioBaseContratos__Opcoes div.v-radio {
    margin-bottom: 0;
  }
  .RelatorioBaseContratos__Opcoes div.v-messages {
    display: none;
  }
  .RelatorioBaseContratos__Opcoes label {
    font-size: 14px;
  }
</style>
